'use es6';

import { useMemo } from 'react';
import BaseFilter from './BaseFilter';
import { TIER } from '../../constants/search/FilterKey';
import * as PartnerTiers from 'marketplace-ui-solutions-core/constants/PartnerTier';
import { translateFilterValue } from '../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const PartnerTierOrder = [PartnerTiers.ELITE, PartnerTiers.DIAMOND, PartnerTiers.PLATINUM, PartnerTiers.GOLD];
export const sortTiers = (tierA, tierB) =>
// legacy filter drilldown uses tierA.value - new drilldown only uses tierA - Remove `.value` when ungating
PartnerTierOrder.indexOf(tierA.value || tierA) - PartnerTierOrder.indexOf(tierB.value || tierB);
const PartnerTierFilter = ({
  filters
}) => {
  const options = useMemo(() => {
    return Object.keys(PartnerTiers).filter(tier => tier !== PartnerTiers.NONE).map(tier => ({
      text: translateFilterValue(TIER, tier),
      value: tier
    }));
  }, []);
  return /*#__PURE__*/_jsx(BaseFilter, {
    filterKey: TIER,
    options: options,
    sortFn: sortTiers,
    value: filters.get(TIER)
  });
};
export default PartnerTierFilter;